<template>
  <ehc-page>
    <ehc-form
      v-model="formData"
      :meta="meta"
      @submit="submit()"
    />
    <v-alert
      v-if="errorMessage"
      type="error"
      :value="true"
    >
      {{ errorMessage }}
    </v-alert>
    <v-btn
      dark
      icon
      large
      color="primary"
      @click="closeTransfer"
    >
      <v-icon dark>mdi-close</v-icon>
    </v-btn>
  </ehc-page>
</template>

<script>
import firebase from "firebase";

export default {
  name: "EhcTransferProp",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pageTitle: "Transfer",
      property: {},
      errorMessage: null,
      formData: {
        isSwitched: true,
        orgId: null,
      },
    };
  },
  computed: {
    meta: function () {
      return [
        {
          type: "text",
          label: "New Organization ID",
          key: "orgId",
          sortOrder: 1,
        },
        {
          type: "switch",
          label: "Transfer Guest Data",
          key: "isSwitched",
          sortOrder: 2,
        },
        { type: "space" },
        {
          type: "button",
          label: "submit",
          key: "submit",
          sortOrder: 3,
          emitOnClick: "submit",
        },
      ].sort((a, b) => a.sortOrder - b.sortOrder);
    },
  },
  methods: {
    async submit() {
      const result = await this.updateProperty(this.value.propertyId);
      if (result) {
        this.$emit("transferComplete", result);
        this.closeTransfer();
      }
    },
    updateProperty: async function (propertyId) {
      this.errorMessage = null;
      const orgId = (this.formData.orgId || "").trim();
      if (!orgId) {
        this.errorMessage = "Organization ID is required";
        return null;
      }

      const orgExists = await this.$store.dispatch("doesOrgExist", orgId);
      if (!orgExists) {
        this.errorMessage = "Organization ID does not exist";
        return null;
      }

      const org = await this.apiGetOrg(orgId);
      const ownerUid =
        org && Array.isArray(org.members) ? org.members[0] : null;
      if (!ownerUid) {
        this.errorMessage = "Organization has no members";
        return null;
      }

      const orgName = org.name || null;
      const ownership = {
        orgId,
        orgName,
        uid: ownerUid,
        userId: ownerUid,
      };

      await this.apiSetProperty(propertyId, ownership);
      await this.syncPropertyCardViewOwnership(propertyId, {
        orgId,
        uid: ownerUid,
      });

      if (this.formData.isSwitched) {
        this.moveGuestData({
          uid: ownerUid,
          propertyId: this.property.propertyId || propertyId,
        });
      }

      return {
        propertyId,
        orgId,
        orgName,
      };
    },
    async syncPropertyCardViewOwnership(propertyId, { orgId, uid }) {
      const viewRef = firebase
        .firestore()
        .collection("propertyCardViews")
        .doc(propertyId);
      const viewSnap = await viewRef.get();
      const payload = {
        propertyId,
        key: propertyId,
        docId: propertyId,
        orgId,
        uid,
      };

      if (viewSnap.exists) {
        await viewRef.set(payload, { merge: true });
        return;
      }

      // Card view missing (out of sync) — create a minimal list row from the property.
      const prop = this.property || {};
      await viewRef.set({
        ...payload,
        name: prop.name || "",
        avatarImg: prop.avatarImg || null,
        city: prop.city || null,
        state: prop.state || null,
        createdAt: prop.createdAt || null,
        updatedAt: prop.updatedAt || Date.now(),
        publishedAt: prop.publishedAt || null,
        showName: prop.showName,
        showAddress: prop.showAddress,
        noguestinfo: prop.noguestinfo,
        contactInfo: {
          hostPhotoUrl: prop.contactInfo?.hostPhotoUrl || null,
        },
        ...(prop.mapAddress?.formatted_address
          ? {
              mapAddress: {
                formatted_address: prop.mapAddress.formatted_address,
              },
            }
          : {}),
      });
    },
    moveGuestData: function (property) {
      this.$store.dispatch("moveGuestDataToUser", {
        uid: property.uid,
        propertyId: property.propertyId,
      });
    },
    closeTransfer: function () {
      this.$emit("closeTransfer");
    },
    resetFormData: function () {
      this.formData.orgId = null;
      this.formData.isSwitched = true;
    },
  },
  async created() {
    this.property = await this.apiGetDoc("properties", this.value.propertyId);
  },
};
</script>
